// Auto-generated from network-ledger.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
/* hero constellation canvas — matches solutions/learn ix-hero animation. */
(function(){
  var cv=document.getElementById('netLedgerHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!cv || reducedH) return;
  var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
  function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
  function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
    hubs=[]; var hn=Math.max(3,Math.round(W/520));
    for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
  var LINK=190;
  function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
    for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy; if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
    for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
    for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
      if(d<LINK){ var al=(1-d/LINK)*0.28; ctx.strokeStyle='rgba(232,217,184,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
        var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
        if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
          ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
    for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
      for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
        if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.22; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
      ctx.fillStyle='rgba(232,217,184,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
    for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(232,217,184,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
    if(running2) raf2=requestAnimationFrame(frame);
  }
  function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
  function stop2(){ running2=false; cancelAnimationFrame(raf2); }
  size(); build(); start2();
  window.addEventListener('resize',function(){ size(); build(); });
  if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
})();
/* Apex monument: count up to the full $100,000,000,000 on scroll-in, then stop. */
(function(){
  var sec = document.getElementById('apex');
  var out = document.getElementById('apexCount');
  if(!sec || !out) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var START  = 90000000000;    // $90,000,000,000
  var TARGET = 100000000000;   // $100,000,000,000
  var DUR = 1000;
  function fmt(n){ return n.toLocaleString('en-US'); }
  function run(){
    if(reduced){ out.textContent = fmt(TARGET); return; }
    var start = null, last = '';
    function ease(t){ return 1 - Math.pow(1 - t, 3); }
    function tick(now){
      if(start===null) start = now;
      var p = Math.min(1, (now - start) / DUR);
      var s = fmt(Math.floor(START + (TARGET - START) * ease(p)));
      if(s !== last){ out.textContent = s; last = s; }
      if(p < 1) requestAnimationFrame(tick);
      else out.textContent = fmt(TARGET);
    }
    out.textContent = fmt(START);
    requestAnimationFrame(tick);
  }
  if(!('IntersectionObserver' in window)){ run(); return; }
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ run(); io.disconnect(); }});
  },{threshold:0.35});
  io.observe(sec);
})();

/* ---------- golden record: precise orbital infrastructure animation ---------- */
(function(){
  var cv=document.getElementById('grCanvas'); if(!cv) return;
  var host=document.getElementById('grStage');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ctx=cv.getContext('2d'), W,H,DPR,cx,cy,scale;
  function resize(){ DPR=Math.min(window.devicePixelRatio||1,2); W=cv.clientWidth;H=cv.clientHeight; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); cx=W/2; cy=H*0.42; scale=Math.min(W/1100,H/620)*1.0; if(scale<=0)scale=1; }
  window.addEventListener('resize',resize); resize();

  var LAVA='255,122,51', CHAMP='168,139,74';
  var RY=0.42;                              // orbital-plane flatten
  var rings=[150,250,350];                  // base radii (scaled at draw)
  var counts=[3,4,5];                       // nodes per ring
  // build node list with per-node angular speed (outer slower) and a packet phase
  var nodes=[];
  rings.forEach(function(r,ri){
    var n=counts[ri], off=ri*0.6, speed=0.05/(1+ri*0.7);
    for(var k=0;k<n;k++){
      nodes.push({ r:r, base:k/n*Math.PI*2+off, speed:speed, ph:Math.random() });
    }
  });

  var running=false, raf=0, t0=performance.now();

  var DOTS_PER_RING=[54,72,90];
  var NLINES=420, maxR=520;     // radial burst — very dense & fine, like the reference

  // scroll-driven intro: 0 = golden globe fills the view, system hidden;
  // 1 = pulled back to the full orbital composition (globe small).
  function introProgress(){
    var r=host.getBoundingClientRect();
    var vh=window.innerHeight||800;
    // progress as the section rises from entering the bottom to reaching center
    var p=(vh - r.top)/(vh*0.9);
    return Math.max(0,Math.min(1,p));
  }
  function easeOut(x){ return 1-Math.pow(1-x,3); }

  function frame(now){
    ctx.clearRect(0,0,W,H);
    var t=(now-t0)*0.001;
    var S=scale;
    var intro=easeOut(introProgress());     // 0..1
    var sysA=Math.max(0,(intro-0.15)/0.85);  // system fades in after the globe starts shrinking

    // 1) dense fine radial line burst forming the elliptical disc (reference look).
    var rot=t*0.03;
    ctx.globalAlpha=sysA;
    for(var i=0;i<NLINES;i++){
      var a=i/NLINES*Math.PI*2+rot;
      var r0=34*S;
      var x0=cx+r0*Math.cos(a), y0=cy+r0*RY*Math.sin(a);
      var x1=cx+maxR*S*Math.cos(a), y1=cy+maxR*RY*S*Math.sin(a);
      // lines are transparent at the core and gain colour outward, so they don't
      // pile into a haze in the middle; the glow comes only from the core sphere.
      var grad=ctx.createLinearGradient(x0,y0,x1,y1);
      grad.addColorStop(0,'rgba('+LAVA+',0)');
      grad.addColorStop(0.18,'rgba('+LAVA+',0.35)');
      grad.addColorStop(0.55,'rgba('+LAVA+',0.8)');
      grad.addColorStop(1,'rgba('+LAVA+',0.8)');
      ctx.strokeStyle=grad; ctx.lineWidth=0.6;
      ctx.beginPath(); ctx.moveTo(x0,y0); ctx.lineTo(x1,y1); ctx.stroke();
    }
    ctx.globalAlpha=1;

    // 2) dotted orbit rings (the blockchains' planes) — subtle, sit on the burst
    rings.forEach(function(r,ri){
      var rr=r*S, rry=r*RY*S, nd=DOTS_PER_RING[ri];
      var spin=t*(0.05/(1+ri*0.7))*Math.PI*2*0.5;
      for(var k=0;k<nd;k++){
        var a=k/nd*Math.PI*2+spin;
        var x=cx+rr*Math.cos(a), y=cy+rry*Math.sin(a);
        var depth=(Math.sin(a)+1)/2;                 // 0 back .. 1 front
        // stronger 3D: front dots much larger & brighter than back dots
        ctx.fillStyle='rgba('+CHAMP+','+(sysA*(0.12+0.45*depth))+')';
        ctx.beginPath(); ctx.arc(x,y,(0.8+depth*1.8)*S,0,7); ctx.fill();
      }
    });

    // helper: live position of a node + its depth (front/back)
    function nodePos(nd){
      var a=nd.base+t*nd.speed*Math.PI*2*0.5;
      return [cx+nd.r*S*Math.cos(a), cy+nd.r*RY*S*Math.sin(a), (Math.sin(a)+1)/2, a];
    }
    // 3) packets flowing inward (chain -> ledger) — bigger, more visible
    nodes.forEach(function(nd,i){
      var pos=nodePos(nd), x=pos[0], y=pos[1];
      var pin=((t*0.28)+nd.ph)%1;
      var ix=x+(cx-x)*pin, iy=y+(cy-y)*pin, fin=Math.sin(pin*Math.PI);
      ctx.fillStyle='rgba('+LAVA+','+(sysA*(0.4+0.6*fin))+')';
      ctx.beginPath(); ctx.arc(ix,iy,(2.0+1.0*fin)*S,0,7); ctx.fill();
    });
    // 3b) packets travelling directly between blockchains (peer sync)
    var HOPS=4;
    for(var e=0;e<HOPS;e++){
      var nA=nodes[(e*2)%nodes.length], nB=nodes[(e*2+3)%nodes.length];
      var pa=nodePos(nA), pb=nodePos(nB);
      var pe=((t*0.2)+e*0.27)%1, fe=Math.sin(pe*Math.PI);
      var hx=pa[0]+(pb[0]-pa[0])*pe, hy=pa[1]+(pb[1]-pa[1])*pe;
      ctx.fillStyle='rgba('+LAVA+','+(sysA*(0.3+0.5*fe))+')';
      ctx.beginPath(); ctx.arc(hx,hy,(1.8+0.8*fe)*S,0,7); ctx.fill();
    }

    // 4) chain nodes as champagne cubes (the blockchains) — depth-sorted, 3D
    var ordered=nodes.map(function(nd){var p=nodePos(nd);return {nd:nd,x:p[0],y:p[1],depth:p[2]};})
                     .sort(function(p,q){return p.depth-q.depth;});   // back first
    ordered.forEach(function(o){
      var depth=o.depth, sz=(7+depth*7)*S;            // front cubes noticeably larger
      ctx.save(); ctx.translate(o.x,o.y); ctx.rotate(Math.PI/4);
      // brighter & lighter in front, darker & dimmer at back for 3D pop
      var faceA=sysA*(0.5+0.5*depth);
      ctx.fillStyle='rgba(254,252,248,'+faceA+')';
      ctx.strokeStyle='rgba('+CHAMP+','+(sysA*(0.45+0.55*depth))+')'; ctx.lineWidth=1.2;
      ctx.fillRect(-sz/2,-sz/2,sz,sz); ctx.strokeRect(-sz/2,-sz/2,sz,sz);
      ctx.restore();
    });

    // 5) central golden record: a spinning golden globe.
    //    starts large (intro=0) and settles to its normal size (intro=1).
    var baseR=30*S;
    var R=baseR*(1 + (1-intro)*4.2);   // up to ~5x at the top, normal once revealed
    var spin=t*0.18;                  // gentle spin, same sense as the orbital drift
    // soft warm halo so the burst doesn't wash the globe out
    var halo=ctx.createRadialGradient(cx,cy,0,cx,cy,R*2.6);
    halo.addColorStop(0,'rgba(250,248,244,0.85)'); halo.addColorStop(0.45,'rgba(250,248,244,0.35)'); halo.addColorStop(1,'rgba(250,248,244,0)');
    ctx.fillStyle=halo; ctx.beginPath(); ctx.arc(cx,cy,R*2.6,0,7); ctx.fill();
    // golden champagne glow ring — gently intensifies when a packet arrives
    var glowA=0.4, glowR=R*1.8;
    var glow=ctx.createRadialGradient(cx,cy,R*0.6,cx,cy,glowR);
    glow.addColorStop(0,'rgba(244,213,138,'+glowA+')'); glow.addColorStop(1,'rgba(212,175,90,0)');
    ctx.fillStyle=glow; ctx.beginPath(); ctx.arc(cx,cy,glowR,0,7); ctx.fill();
    // the golden globe body: bright gold highlight -> champagne gold -> deep bronze rim
    var hi = '#FFF3D4';
    var sph=ctx.createRadialGradient(cx-R*0.32,cy-R*0.34,R*0.05,cx,cy,R);
    sph.addColorStop(0,hi); sph.addColorStop(0.35,'#F4D58A'); sph.addColorStop(0.7,'#C9A24B'); sph.addColorStop(1,'#8A6B2E');
    ctx.fillStyle=sph; ctx.beginPath(); ctx.arc(cx,cy,R,0,7); ctx.fill();
    // rotating surface: meridian lines (longitudes) sweeping around to show spin
    ctx.save();
    ctx.beginPath(); ctx.arc(cx,cy,R-0.5,0,7); ctx.clip();   // keep lines on the globe
    ctx.strokeStyle='rgba(138,107,46,0.45)'; ctx.lineWidth=1;
    var MER=5;
    for(var m=0;m<MER;m++){
      var phase=spin + m/MER*Math.PI*2;
      var cosp=Math.cos(phase);            // ellipse half-width (signed)
      var sinp=Math.sin(phase);            // front (+) vs back (-) facing
      // brighter when front-facing, faint when wrapping the back -> clear direction
      var vis=0.12+0.4*Math.max(0,sinp);
      ctx.strokeStyle='rgba(138,107,46,'+vis+')'; ctx.lineWidth=1;
      ctx.beginPath(); ctx.ellipse(cx,cy,Math.abs(cosp)*R,R,0,0,Math.PI*2); ctx.stroke();
    }
    // equator for reference
    ctx.strokeStyle='rgba(138,107,46,0.28)';
    ctx.beginPath(); ctx.ellipse(cx,cy,R,R*0.26,0,0,Math.PI*2); ctx.stroke();
    ctx.restore();
    // thin champagne rim
    ctx.strokeStyle='rgba(232,217,184,0.75)'; ctx.lineWidth=1; ctx.beginPath(); ctx.arc(cx,cy,R,0,7); ctx.stroke();
    // fixed specular highlight (light source stays put while the surface spins)
    var spec=ctx.createRadialGradient(cx-R*0.34,cy-R*0.36,0,cx-R*0.34,cy-R*0.36,R*0.55);
    spec.addColorStop(0,'rgba(255,252,244,0.85)'); spec.addColorStop(1,'rgba(255,252,244,0)');
    ctx.fillStyle=spec; ctx.beginPath(); ctx.arc(cx-R*0.3,cy-R*0.32,R*0.5,0,7); ctx.fill();

    // 6) label below the disc (fades in with the system)
    var ly=cy+maxR*RY*S+30;
    ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillStyle='rgba('+LAVA+','+(0.95*sysA)+')';
    ctx.font='10px "JetBrains Mono", ui-monospace, monospace';
    ctx.fillText('G O L D E N   R E C O R D', cx, ly);
    if(running && !reduced) raf=requestAnimationFrame(frame);
  }
  if(reduced){ frame(performance.now()); return; }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting && !running){ running=true; raf=requestAnimationFrame(frame); }
      else if(!e.isIntersecting && running){ running=false; cancelAnimationFrame(raf); }
    });},{threshold:0.05}); io.observe(host);
  } else { running=true; raf=requestAnimationFrame(frame); }
})();


/* ---------- orchestrates: hover the Ledger bar to fire dots along the connectors ---------- */
(function(){
  var layer=document.querySelector('.orch-diagram .ocl-layer');
  var conns=document.querySelector('.orch-diagram .ocl-connectors');
  if(!layer||!conns) return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced) return;
  var lines=Array.prototype.slice.call(conns.querySelectorAll('span'));
  var active=false, timers=[];

  function fire(span){
    var dot=span.querySelector('.ocl-dot'); if(!dot) return;
    var h=span.clientHeight||48;
    var down=Math.random()<0.5;            // random direction
    var dur=900+Math.random()*900;
    var t0=performance.now();
    dot.classList.add('run');
    (function step(now){
      var p=Math.min(1,(now-t0)/dur);
      var e=p<0.5?2*p*p:1-Math.pow(-2*p+2,2)/2;   // ease in-out
      var y=down ? e*h : (1-e)*h;
      dot.style.transform='translateY('+y+'px)';
      // fade at the ends
      dot.style.opacity=String(Math.sin(p*Math.PI));
      if(p<1 && active){ requestAnimationFrame(step); }
      else { dot.classList.remove('run'); dot.style.opacity='0'; }
    })(t0);
  }

  function schedule(){
    if(!active) return;
    // fire on a random subset of lines, then schedule the next burst
    var k=1+Math.floor(Math.random()*3);     // 1–3 lines at a time
    for(var i=0;i<k;i++){ fire(lines[Math.floor(Math.random()*lines.length)]); }
    var t=setTimeout(schedule, 350+Math.random()*550);
    timers.push(t);
  }
  function start(){ if(active)return; active=true; schedule(); }
  function stop(){ active=false; timers.forEach(clearTimeout); timers=[]; }

  layer.addEventListener('mouseenter', start);
  layer.addEventListener('mouseleave', stop);
  layer.addEventListener('focusin', start);
  layer.addEventListener('focusout', stop);
})();

/* ---------- who operates: expanding panels ---------- */
(function(){
  var sec=document.getElementById('opPanels'); if(!sec) return;
  var panels=Array.prototype.slice.call(sec.querySelectorAll('.opanel'));
  function activate(n){ panels.forEach(function(p){ p.classList.toggle('active', +p.dataset.panel===n); }); }
  panels.forEach(function(p){
    var n=+p.dataset.panel;
    p.addEventListener('mouseenter',function(){ activate(n); });
    p.addEventListener('focusin',function(){ activate(n); });
    p.addEventListener('click',function(){ activate(n); });
  });
  activate(1);
})();
`;
